<template>
    <div class="main">
        <div class="title">
            <div class="name">专家信息</div>
        </div>
        <div class="tab">
            <span @click="to">+ 新增专家</span>
            <span>
        <el-upload
            :action="baseURL + daoru"
            :before-upload="beforeAvatarUpload"
            :data="Data"
            :on-success="handleAvatarSuccess"
            :show-file-list="false"
            accept=".xlsx"
            class="avatar-uploader">
             专家导入
        </el-upload>
      </span>
            <span><a :href="baseURL + daochu + 'mid=' + user.mid+ '&search_type='+ search.value +'&search_name=' + search.input + '&search_cate=' + search.cate+ '&search_state=1'" download target="_blank">专家导出</a></span>
            <span><a :href="muban" download target="_blank">模板下载</a></span>
        </div>
        <div class="list-box">
            <div class="search-box">
                <div class="select-box">
                    <el-select v-model="search.cate" clearable placeholder="请选择专家分类" @change="search.value = '',getExpertType">
                        <el-option
                            v-for="item in cate_lists"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="select-box">
                    <el-select v-model="search.value" class="margin-left-xs" clearable placeholder="请选择专家领域">
                        <el-option
                            v-for="item in options"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="input-box">
                    <el-input v-model="search.input" placeholder="请输入专家姓名" style="width: 100%;"></el-input>
                    <div @click="list">
                        <i class="iconfont icon-sousuo"></i>
                        <span>搜索</span>
                    </div>
                </div>
                <div class="chongz" @click="reset">重置</div>

                <div class="chongz">
                    专家数量（{{ total }}）
                </div>

            </div>
            <el-table
                v-loading="loading"
                :cell-style="{'text-align':'center'}"
                :data="tableData"
                :header-cell-style="{
            'text-align':'center',
            'height':'58px',
            'background-color':'#dae0e6',
            'color':'#333'}"
                border
                style="width: 100%;border-radius: 10px;">
                <el-table-column
                    :index="(index) => { return ((page - 1) * limit + index + 1)}"
                    label="序号"
                    type="index"
                    width="65">
                </el-table-column>
                <el-table-column
                    label="专家姓名"
                    prop="name"
                    width="110">
                    <div slot="header">
                        <div class="flex justify-center align-center pointer" @click="sort('name')">
                            <div>专家姓名</div>
                            <div class="flex flex-direction margin-left-xs">
                                <i :class="{iconactive : nameSort == 1}" class="el-icon-caret-top"></i>
                                <i :class="{iconactive : nameSort == 2}" class="el-icon-caret-bottom"></i>
                            </div>
                        </div>
                    </div>
                </el-table-column>
                <el-table-column
                    label="手机号"
                    prop="phone_number"
                    width="120">
                </el-table-column>
                <el-table-column
                    label="分类"
                    prop="cate_name"
                    width="120">
                </el-table-column>
                <el-table-column
                    label="领域"
                    prop="type_text"
                    width="120">
                </el-table-column>
                <el-table-column
                    label="预约数量"
                    prop="yuyue_all_count"
                    width="110">
                    <div slot="header">
                        <div class="flex justify-center align-center pointer" @click="sort('yuyue_count')">
                            <div>预约数量</div>
                            <div class="flex flex-direction margin-left-xs">
                                <i :class="{iconactive : numSort == 1}" class="el-icon-caret-top"></i>
                                <i :class="{iconactive : numSort == 2}" class="el-icon-caret-bottom"></i>
                            </div>
                        </div>
                    </div>
                </el-table-column>
                <el-table-column
                    label="简介"
                >
                    <template slot-scope="scope">
                        <div class="ovHide3" v-html="scope.row.desc"></div>
                    </template>
                </el-table-column>
                <!--        <el-table-column-->
                <!--            label="照片"-->
                <!--            width="90">-->
                <!--          <template slot-scope="scope">-->
                <!--            <img :src="urlStr + scope.row.pic" alt="" style="width: 65px;height: 77px;object-fit: scale-down">-->
                <!--&lt;!&ndash;            <img v-else src="../../../assets/images/moren.png" alt="" style="width: 65px;height: 77px;object-fit: scale-down">&ndash;&gt;-->
                <!--          </template>-->
                <!--        </el-table-column>-->
                <el-table-column
                    label="是否显示"
                    width="80">
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.is_show"
                            :active-value="1"
                            :inactive-value="0"
                            @change="showload($event,scope.row.id)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="200">
                    <template slot-scope="scope">
                        <el-button class="margin-right-xs" size="small" type="primary" @click="yuyue(scope.row.id, 1)">详情</el-button>
                        <el-dropdown @command="handleCommand">
                            <el-button size="small" type="primary">
                                更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <!--                <el-dropdown-item :command="beforeHandleCommand(scope.row.id,1)">预约记录</el-dropdown-item>-->
                                <el-dropdown-item :command="beforeHandleCommand(scope.row.id,2)">去预约</el-dropdown-item>
                                <el-dropdown-item :command="beforeHandleCommand(scope.row.id,3)">编辑</el-dropdown-item>
                                <el-dropdown-item :command="beforeHandleCommand(scope.row.id,4)">删除</el-dropdown-item>
                                <el-dropdown-item :command="beforeHandleCommand(scope.row.id,5)">评价</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>

                        <!--            <div class="flex justify-between flex-wrap">-->
                        <!--              <el-button-->
                        <!--                  size="small"-->
                        <!--                  type="primary"-->
                        <!--                  class="edit"-->
                        <!--                  style="width: 90px;margin-top: 0;"-->
                        <!--                  round-->
                        <!--                  @click="yuyue(scope.row.id,1)">预约记录</el-button>-->
                        <!--              <el-button-->
                        <!--                size="small"-->
                        <!--                type="primary"-->
                        <!--                class="edit"-->
                        <!--                style="width: 80px;margin-top: 0;"-->
                        <!--                round-->
                        <!--                @click="yuyue(scope.row.id,2)">去预约</el-button>-->
                        <!--              <el-button-->
                        <!--                  size="small"-->
                        <!--                  type="primary"-->
                        <!--                  class="edit"-->
                        <!--                  round-->
                        <!--                  @click="go(scope.row.id)">编辑</el-button>-->
                        <!--              <el-button-->
                        <!--                  size="small"-->
                        <!--                  class="del"-->
                        <!--                  round-->
                        <!--                  @click="handleDelete(scope.row.id)">删除</el-button>-->
                        <!--              <el-button-->
                        <!--                size="small"-->
                        <!--                type="primary"-->
                        <!--                class="edit"-->
                        <!--                round-->
                        <!--                @click="goEvaluate(scope.row.id)">评价</el-button>-->
                        <!--            </div>-->
                    </template>
                </el-table-column>
            </el-table>
            <div class="page-box">
                <el-pagination
                    :current-page.sync="page"
                    :page-size="limit"
                    :total="total"
                    background
                    class="page-all margin-top self-end"
                    layout="total,prev, pager, next,jumper"
                    @current-change="list">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import {catelist, expertDel, Expertlist, expertSetShow, getExpertType, getMoBAN, getSetting} from "@/api/index";
import {baseURL, urlStr} from "@/config";

export default {
    name: "detail",
    data() {
        return {
            loading: false,
            urlStr: urlStr,
            baseURL: baseURL,
            nameSort: 2, // 1 正序 2 倒序
            numSort: '', // 1 正序 2 倒序
            oid: '',
            Data: {
                mid: ''
            },
            daochu: '/api/expert/exportToExcel?',
            daoru: '/api/expert/importByExcel',
            muban: '',
            active: 1,
            id: '',
            search: {
                value: '',
                cate: '',
                input: ''
            },
            options: [],
            cate_lists: [],
            tableData: [],
            page: 1,
            limit: 10,
            total: 0,
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    components: {},
    created() {
        this.$emit("setActive", {
            active: 1,
            act: 2,
            name: '专家管理 > 专家信息'
        })
        this.Data.mid = this.user.mid
        this.getSetting()
        this.init()
        this.getExpertType()
        this.list()
        this.getBAN()
    },
    methods: {

        handleCommand(command) {
            switch (command.command) {
                case 1://预约记录
                    this.yuyue(command.id, 1);
                    break;
                case 2://去预约
                    this.yuyue(command.id, 2);
                    break;
                case 3://编辑
                    this.go(command.id);
                    break;
                case 4://删除
                    this.handleDelete(command.id);
                    break;
                case 5://评价
                    this.goEvaluate(command.id);
                    break;
            }
        },
        beforeHandleCommand(id, command) {
            return {
                'id': id,
                'command': command
            }
        },

        sort(name) {
            if (name == 'name') {
                this.nameSort = this.nameSort == 1 ? 2 : (this.nameSort == 2 ? '' : 1)
            }
            if (name == 'yuyue_count') {
                this.numSort = this.numSort == 1 ? 2 : (this.numSort == 2 ? '' : 1)
            }
            this.list()
        },

        handleDelete(id) {
            this.$confirm('此操作将删除该数据，是否继续?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.expertDel(id)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },

        async getSetting() {
            let _res = await getSetting(
                this.user.mid
            );
            if (_res.status === 200) {
                this.oid = _res.data.setting.oid
            } else {
                this.$message.error(_res.msg)
            }
        },

        // 删除专家
        async expertDel(id) {
            let _res = await expertDel(
                this.user.mid,
                id
            );
            if (_res.status === 200) {
                this.$message.success(_res.msg);
                this.list()
            } else {
                this.$message.error(_res.msg);
            }
        },

        // 获取列表
        async list() {
            this.loading = true
            let _res = await Expertlist(
                this.user.mid,
                this.nameSort,
                this.numSort,
                1,
                this.search.value,
                this.search.cate,
                this.search.input,
                this.page, this.limit
            );
            this.loading = false
            if (_res.status === 200) {
                this.tableData = _res.data
                this.total = _res.total_number
                _res.data.map(item => {
                    let ary = JSON.parse(item.job)
                    let arr = []
                    ary.map(itm => {
                        arr.push(itm.value)
                    })
                    item.job_text = arr.join('、')
                })
            } else {
                this.$message.error(_res.msg)
            }
        },
        async init() {
            let _data = await catelist(
                this.user.mid,
                1,
                999
            )
            this.cate_lists = _data.data
        },
        // 获取分类
        async getExpertType() {
            let _res = await getExpertType(
                this.user.mid
            );
            if (_res.status === 200) {
                this.options = _res.data
            } else {
                this.$message.error(_res.msg);
            }
        },

        // 显示隐藏
        async showload(bool, id) {
            console.log(bool)
            let _res = await expertSetShow(
                this.user.mid,
                id
            );
            if (_res.status === 200) {
                this.$message.success(_res.msg);
                this.list()
            } else {
                this.$message.error(_res.msg);
            }
        },

        // 获取模板链接
        async getBAN() {
            let _res = await getMoBAN(
                this.user.mid
            );
            if (_res.status === 200) {
                this.muban = _res.data.url
            } else {
                this.$message.error(_res.msg)
            }
        },

        //  上传成功
        handleAvatarSuccess(response) {
            this.uping.close();
            if (response.status === 200) {
                this.$message.success(response.msg)
                this.list()
            } else {
                this.$message.success(response.msg)
            }
        },
        //  上传失败
        uploadError() {
            this.uping.close();
            this.$message({
                message: "上传出错，请重试！",
                type: "error",
                center: true,
            });
        },

        beforeAvatarUpload() {
            this.uping = this.$loading({
                lock: true,
                text: "上传中，请稍后",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.2)",
            });
        },

        reset() {
            this.search.value = ''
            this.search.cate = ''
            this.search.input = ''
            this.list()
        },

        go(id) {
            this.$router.push({
                path: '/home/examineDetail',
                query: {
                    id: id,
                    act: 2
                }
            })
        },

        goEvaluate(id) {
            this.$router.push({
                path: '/home/evaluate',
                query: {
                    id: id,
                    act: 2
                }
            })
        },

        to() {
            this.$router.push({
                path: '/checkin',
                query: {
                    register_type: 2,
                    showId: this.oid
                }
            })
        },

        yuyue(id, type) {
            let path;
            if (type == 1) {
                // 预约记录
                path = '/home/detailYuyue'
            }
            if (type == 2) {
                // 预约填报
                path = '/home/examineYuyue'
            }
            this.$router.push({
                path: path,
                query: {
                    id: id
                }
            })
        }
    },
    watch: {},
    filters: {}
}
</script>

<style lang="scss" scoped>

.el-icon-caret-top {
    color: #999999;
}

.el-icon-caret-bottom {
    color: #999999;
}

.iconactive {
    color: #000000;
}

.show {
    width: 70px;
    height: 30px;
    background-color: #ff9600;
    border: 1px solid #ff9600;
    line-height: 28px;
    padding: 0;
    border-radius: 15px;
    color: #ffffff;
    margin-top: 5px;
}

.hide {
    width: 70px;
    height: 30px;
    background-color: #dae0e6;
    border: 1px solid #dae0e6;
    line-height: 28px;
    padding: 0;
    border-radius: 15px;
    color: #ffffff;
    margin-top: 5px;
}

.del {
    width: 55px;
    height: 30px;
    border-radius: 15px;
    border: solid 1px #0a2240;
    line-height: 28px;
    padding: 0;
    color: #0a2240;
    margin-left: 0;
    margin-top: 5px;
}

.edit {
    width: 55px;
    height: 30px;
    background-color: #0a2240;
    line-height: 28px;
    padding: 0;
    border-radius: 15px;
    margin-top: 5px;
    margin-left: 0;
}

.main {
    display: flex;
    flex-direction: column;

    .title {
        padding: 5px 8px 15px 8px;

        .name {
            font-size: 20px;
            color: #ffffff;
            font-weight: bold;
        }
    }

    .tab {
        width: 100%;
        display: flex;
        justify-content: space-between;
        background-color: #ffffff;
        padding: 10px;
        border-radius: 10px;

        span {
            width: 236px;
            height: 50px;
            background-color: #f3f7fb;
            border-radius: 10px;
            border: solid 1px #dae0e6;
            font-size: 18px;
            color: #0a2240;
            text-align: center;
            line-height: 48px;
            cursor: pointer;

            a {
                font-size: 18px;
                color: #0a2240;
            }

            &:hover {
                background-color: #ff9600;
                border: solid 1px #ff9600;
                color: #ffffff;

                a {
                    color: #ffffff;
                }
            }
        }
    }

    .list-box {
        width: 100%;
        background-color: #ffffff;
        border-radius: 10px;
        padding: 15px;
        margin-top: 20px;
        flex: 1;

        .search-box {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;

            .select-box {
                width: 162px;
            }

            .chongz {
                min-width: 90px;
                width: max-content;
                padding: 0 15px;
                height: 40px;
                background-color: #0a2240;
                border-radius: 5px;
                font-size: 16px;
                color: #ffffff;
                cursor: pointer;
                text-align: center;
                line-height: 40px;
                margin-left: 15px;
            }

            .input-box {
                flex: 1;
                width: 0;
                margin-left: 15px;
                display: flex;
                height: 40px;
                overflow: hidden;
                justify-content: space-between;
                border-radius: 5px;

                > div {
                    width: 100px;
                    height: 40px;
                    background-color: #0a2240;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;

                    span {
                        font-size: 16px;
                        color: #ffffff;
                    }

                    i {
                        margin-right: 4px;
                        color: #ffffff;
                        font-size: 18px;
                    }
                }
            }
        }

    }
}
</style>


